import React, { useEffect } from "react";
import SEO from "../components/shared/SEO";
import { ServicesHeader } from "./components/ServicesHeader";
import { ServiceFeatures } from "./components/ServiceFeatures";
import { WorkflowAutomation } from "./components/WorkflowAutomation";
import { ServiceProcess } from "./components/ServiceProcess";
import { ServiceCTA } from "./components/ServiceCTA";
import { Footer } from "../components/shared/Footer";
import AIAssessmentPromo from "../home/components/AIAssessmentPromo";

export default function Page() {
  useEffect(() => {
    // Check if we need to scroll to a section
    const scrollTarget = sessionStorage.getItem('scrollTarget');
    if (scrollTarget) {
      // Clear the storage
      sessionStorage.removeItem('scrollTarget');
      // Wait a bit for the page to fully render
      setTimeout(() => {
        const element = document.getElementById(scrollTarget);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 500);
    }
  }, []);

  return (
    <>
      <SEO 
        title="AI Consulting & Software Development Services | Omnigeist"
        description="Expert AI consulting services including custom AI development, business automation, software modernization, and digital transformation. Specializing in Microsoft technologies, .NET, Azure, and intelligent automation solutions."
        keywords="AI consulting services, custom AI development, business automation, software modernization, digital transformation, Microsoft consulting, .NET development, Azure solutions, AI integration"
        ogTitle="AI Consulting & Development Services - Omnigeist"
        ogDescription="Transform your business with expert AI consulting and software development services. Custom solutions for automation, modernization, and intelligent systems."
        canonical="https://omnigeist.com/services"
      />
      <div>
        <div className="flex justify-center">
        <div className="w-full max-w-7xl">
          <AIAssessmentPromo />
        </div>
      </div>
      <ServicesHeader />
      <ServiceFeatures />
      <WorkflowAutomation />
      <ServiceProcess />
      <ServiceCTA />
      <Footer />
    </div>
    </>
  );
}
